module.exports = __webpack_public_path__ + "img/ec.df3a0094.svg";